import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { CollectionFragmentExtended } from '../hasura-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionByContractAddressVariables = Types.Exact<{
  contractAddress: Types.Scalars['String'];
}>;


export type CollectionByContractAddress = { collections: Array<(
    Pick<Types.Collection, 'chainId' | 'collectionImageUrl' | 'contractAddress' | 'slug' | 'coverImageUrl' | 'createdAt' | 'creatorAddress' | 'description' | 'id' | 'name' | 'symbol' | 'updatedAt' | 'contractType' | 'moderationStatus' | 'moderationFrom' | 'hiddenAt' | 'deletedAt' | 'baseURI' | 'maxTokenId' | 'isRevealed' | 'brandColor'>
    & { creator: Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>, splits: Array<(
      Pick<Types.Split_Recipient, 'id' | 'contractAddress' | 'indexOfShare' | 'publicKey' | 'sharePercent'>
      & { user: Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
    )> }
  )> };



export const CollectionByContractAddressDocument = /*#__PURE__*/ `
    query CollectionByContractAddress($contractAddress: String!) {
  collections: collection(where: {contractAddress: {_eq: $contractAddress}}) {
    ...CollectionFragmentExtended
  }
}
    ${CollectionFragmentExtended}`;

export const useCollectionByContractAddress = <
      TData = CollectionByContractAddress,
      TError = ClientError
    >(
      variables: CollectionByContractAddressVariables,
      options?: Omit<UseQueryOptions<CollectionByContractAddress, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionByContractAddress, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionByContractAddress, TError, TData>(
      {
    queryKey: ['CollectionByContractAddress', variables],
    queryFn: hasuraFetcher<CollectionByContractAddress, CollectionByContractAddressVariables>(CollectionByContractAddressDocument, variables),
    ...options
  }
    )};

useCollectionByContractAddress.getKey = (variables: CollectionByContractAddressVariables) => ['CollectionByContractAddress', variables];

export const useInfiniteCollectionByContractAddress = <
      TData = InfiniteData<CollectionByContractAddress>,
      TError = ClientError
    >(
      variables: CollectionByContractAddressVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionByContractAddress, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionByContractAddress, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionByContractAddress, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionByContractAddress.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionByContractAddress, CollectionByContractAddressVariables>(CollectionByContractAddressDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionByContractAddress.getKey = (variables: CollectionByContractAddressVariables) => ['CollectionByContractAddress.infinite', variables];


useCollectionByContractAddress.fetcher = (variables: CollectionByContractAddressVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionByContractAddress, CollectionByContractAddressVariables>(CollectionByContractAddressDocument, variables, options);
